import type { ChatMessage } from '../hooks/use-chat-ws';
import { buildSegments } from './chat-segments';
import { isJourneyAgent, isJourneySpawn, isTerminalTaskStatus, journeyGroupStatus } from './journey-attribution';
import { latestUnansweredQuestionId } from './unanswered-question';

export const hasRunningJourneys = (messages: ChatMessage[]): boolean => {
  const renderable = messages.map((msg, originalIndex) => ({ msg, originalIndex }));
  const groupedSpawnIds = new Set<string>();
  for (const segment of buildSegments(renderable)) {
    if (segment.kind !== 'journey_group') continue;
    groupedSpawnIds.add(segment.spawnId);
    if (isJourneyAgent(segment.agent) && !isTerminalTaskStatus(journeyGroupStatus(segment.messages))) return true;
  }
  return messages.some(msg => msg.type === 'tool_use' && isJourneySpawn(msg) && !groupedSpawnIds.has(msg.id));
};

export const hasUnansweredQuestion = (messages: ChatMessage[]): boolean => {
  return latestUnansweredQuestionId(messages) !== undefined;
};
